const FIELD_LABELS = {
  name: "Nama",
  legal_name: "Nama legal",
  email: "Email",
  phone: "Nomor telepon",
  image: "Gambar",
  logo: "Logo",
  banner: "Banner",
  qris_image: "Gambar QRIS",
  qris_payload: "Payload QRIS",
  primary_color: "Warna utama",
  category: "Kategori",
  type: "Tipe",
  unit: "Satuan",
  unit_price: "Harga jual",
  unit_cost: "Harga material",
  stock: "Stok",
  min_stock: "Stok minimum",
  max_stock: "Stok maksimum",
  label: "Nama varian",
  sku: "SKU",
  material_id: "Bahan resep",
  weight: "Isi/berat",
  qty: "Jumlah",
  process_type: "Jenis proses",
  default_yield_percent: "Persentase hasil",
};

const humanizeField = (field = "data") => {
  const parts = String(field).split(".");
  const variantIndex = parts[0] === "variants" && /^\d+$/.test(parts[1] || "") ? Number(parts[1]) + 1 : null;
  const recipePosition = parts.indexOf("recipes");
  const recipeIndex =
    recipePosition >= 0 && /^\d+$/.test(parts[recipePosition + 1] || "") ? Number(parts[recipePosition + 1]) + 1 : null;
  const key = [...parts].reverse().find((part) => !/^\d+$/.test(part) && part !== "variants" && part !== "recipes");
  const label = FIELD_LABELS[key] || String(key || "data").replaceAll("_", " ");

  if (variantIndex && recipeIndex) return `${label} ke-${recipeIndex} pada varian ke-${variantIndex}`;
  if (variantIndex) return `${label} pada varian ke-${variantIndex}`;

  return label.charAt(0).toUpperCase() + label.slice(1);
};

const translateValidationMessage = (message, field = "") => {
  const text = String(message || "").trim();
  if (!text) return "Data belum dapat diproses.";

  const technicalField = text.match(/^The (.+?) field /i)?.[1] || field;
  const label = humanizeField(technicalField);

  if (/has a duplicate value/i.test(text)) return `${label} tidak boleh dipilih lebih dari sekali.`;
  if (/field is required/i.test(text)) return `${label} wajib diisi.`;
  if (/selected .* is invalid/i.test(text) || /field must exist/i.test(text)) return `${label} yang dipilih tidak tersedia.`;
  if (/must be a number|must be numeric/i.test(text)) return `${label} harus berupa angka.`;
  if (/must be an integer/i.test(text)) return `${label} harus berupa bilangan bulat.`;
  if (/must be at least/i.test(text)) return `${label} terlalu kecil.`;
  if (/must not be greater than|may not be greater than/i.test(text)) return `${label} melebihi batas yang diperbolehkan.`;
  if (/must be an image/i.test(text)) return `${label} harus berupa file gambar.`;
  if (/must be a file of type/i.test(text)) return `Format ${label.toLowerCase()} tidak didukung.`;

  return text
    .replace(/^Unprocessable Entity\.?$/i, "Data belum dapat diproses.")
    .replace(/^Internal Server Error\.?$/i, "Terjadi kendala pada server. Silakan coba kembali.");
};

const flattenErrors = (errors) => {
  if (!errors || typeof errors !== "object") return [];

  return Object.entries(errors).flatMap(([field, messages]) =>
    (Array.isArray(messages) ? messages : [messages]).map((message) => translateValidationMessage(message, field)),
  );
};

export const getReadableApiError = (error, fallback = "Terjadi kesalahan. Silakan coba kembali.") => {
  const response = error?.response;
  const payload = response?.data;
  const errors = payload?.data?.errors || payload?.errors;
  const validationMessages = flattenErrors(errors);

  if (validationMessages.length) {
    return [...new Set(validationMessages)].slice(0, 4).join(" ");
  }

  const rawMessage = typeof payload?.message === "string" ? payload.message.trim() : "";
  if (rawMessage) {
    const messages = rawMessage.split(/,\s*(?=The\s)/i).map((message) => translateValidationMessage(message));
    return [...new Set(messages)].slice(0, 4).join(" ");
  }

  if (!response) return "Tidak dapat terhubung ke server. Periksa koneksi internet lalu coba kembali.";
  if (response.status === 413) return "Ukuran file terlalu besar. Pilih gambar yang lebih kecil.";

  return typeof fallback === "string" && fallback.trim()
    ? fallback
    : "Terjadi kesalahan. Silakan coba kembali.";
};

